import React, { useState } from "react";
import API from "../../services/api.ts";
import { toast } from "react-toastify";
import "./Datasets.css";

const AssignProjectModal = ({ dataset, projects, onClose, onSuccess }) => {
    const [selectedProject, setSelectedProject] = useState(dataset.project || "");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            await API.patch(`/datasets/${dataset.id}/`, {
                project: selectedProject || null,
            });

            if (selectedProject) {
                const projectName = projects.find(p => p.id.toString() === selectedProject.toString())?.name;
                toast.success(`Dataset assigned to "${projectName}"`);
            } else {
                toast.success("Dataset unassigned from project");
            }
            onSuccess();
        } catch (err) {
            console.error("Error assigning dataset:", err);
            toast.error("Failed to update dataset.");
        } finally {
            setLoading(false);
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-backdrop-custom" onClick={handleBackdropClick}>
            <div className="modal-content-custom">
                <div className="modal-header-custom">
                    <h3>Assign to Project</h3>
                    <button className="modal-close-btn" onClick={onClose}>
                        &times;
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body-custom">
                        <p className="text-muted mb-3">
                            Assign <strong>{dataset.name}</strong> to a project to enable collaboration.
                        </p>

                        <div className="form-group">
                            <label className="form-label">Select Project</label>
                            <select
                                className="form-control"
                                value={selectedProject}
                                onChange={(e) => setSelectedProject(e.target.value)}
                            >
                                <option value="">-- No Project (Unassign) --</option>
                                {projects.map((project) => (
                                    <option key={project.id} value={project.id}>
                                        {project.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {selectedProject && (
                            <div className="mt-3 p-3 bg-light rounded">
                                <small className="text-muted">
                                    <i className="fa fa-info-circle me-2"></i>
                                    Once assigned, project members will be able to access this dataset.
                                </small>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer-custom">
                        <button
                            type="button"
                            className="btn-secondary-custom"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn-primary-custom"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" />
                                    Saving...
                                </>
                            ) : selectedProject ? (
                                "Assign to Project"
                            ) : (
                                "Unassign"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AssignProjectModal;
